import {
  GetProfileChangeLogsResponseSchema,
  profileChangeLogsContract,
} from "@clipboard-health/contract-backend-main";
import { useInfiniteGetParsedQuery } from "@src/appV2/api/useInfiniteGetParsedQuery";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

// Backend-enforced: the /profileChangeLogs endpoint has no page-size param and always returns 10.
const PAGE_SIZE = 10;

const queryParamsSchema = profileChangeLogsContract.getProfileChangeLogs.query;

export interface UseGetProfileChangeLogsParams {
  id: string;
}

export function useGetProfileChangeLogs(
  params: UseGetProfileChangeLogsParams,
  options: { enabled?: boolean } = {}
) {
  return useInfiniteGetParsedQuery({
    url: "/profileChangeLogs",
    queryParams: { id: params.id, skip: 0 },
    queryParamsSchema,
    responseSchema: GetProfileChangeLogsResponseSchema,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.logs.length >= PAGE_SIZE ? { skip: allPages.length * PAGE_SIZE } : undefined,
    enabled: options.enabled,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_PROFILE_CHANGE_LOGS_FAILURE },
  });
}
